import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { Form } from 'antd';
import { Popup, TextArea, TYPOGRAPHY_WEIGHT } from '_atoms';
import { Typography } from '_atoms/Typography';
import { BUTTON_TEXT } from 'constants/text';
import { RULES } from '_templates/CreateOpening/constants';
import './style.scss';

/* Callers pass either the shared `Opening` entity or `_atoms/Opening`'s own `OpeningData` —
   two independent domain shapes that agree only on these fields, which is all this popup needs. */
interface OpeningSummary {
  level?: string;
  custom_level?: string;
  expected?: string;
}

interface PopupPauseOpeningProps {
  open: boolean;
  opening: OpeningSummary;
  jobName: string;
  onClose: () => void;
  onSubmit: (values: { comment: string }) => void;
}

export const PopupPauseOpening: React.FC<PopupPauseOpeningProps> = ({ open, opening, jobName, onClose, onSubmit }) => {
  const { t } = useTranslation();

  return (
    <Popup
      open={open}
      title={t('translation:popup_pause_opening.title')}
      cancelButtonProps={{
        onClick: onClose,
        children: BUTTON_TEXT.CANCEL,
      }}
      okButtonProps={{
        children: BUTTON_TEXT.CONFIRM,
        form: 'form-pause-opening',
        htmlType: 'submit',
      }}
      className="popup-pause-opening mobile-full-size"
    >
      <div className="popup-pause-opening__subtitle">
        <Typography.Text className="popup-close-opening__title" weight={TYPOGRAPHY_WEIGHT.BOLD}>
          {`${opening.custom_level || opening.level} ${jobName}`}
        </Typography.Text>
        <Typography.Caption className="popup-close-opening__subtitle">
          {t('translation:popup_pause_opening.text_expected_on', {
            date: moment(opening.expected).format('MMM DD, YYYY'),
          } as Record<string, unknown>)}
        </Typography.Caption>
      </div>
      <Typography.Text className="popup-pause-opening__text">
        {t('translation:popup_pause_opening.text')}
      </Typography.Text>
      <Form name="form-pause-opening" validateTrigger="onSubmit" onFinish={onSubmit}>
        <TextArea
          label={t('translation:popup_pause_opening.label_comment')}
          placeholder={t('translation:popup_pause_opening.ph_comment')}
          maxLength={2000}
          itemProps={{ name: 'comment', rules: RULES.REQUIRED }}
        />
      </Form>
    </Popup>
  );
};
